export default "/_next/static/models/badge-739eda7777380466a355c36e56ee7f50.glb";